// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gpoBW","rootNoMargin":"styles_rootNoMargin__na7vg"};